import { render } from "./personalAgain.vue?vue&type=template&id=90b85eae&scoped=true"
import script from "./personalAgain.vue?vue&type=script&lang=js"
export * from "./personalAgain.vue?vue&type=script&lang=js"

import "./personalAgain.vue?vue&type=style&index=0&id=90b85eae&lang=less&scoped=true"

import exportComponent from "D:\\rwkj\\suershouyyph-mobile\\保安端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b85eae"]])

export default __exports__